import setWith from 'lodash/fp/setWith';
import clone from 'lodash/fp/clone';

export const setIn = (path, value, obj) => setWith(Object, path, value, clone(obj));
